import { render, staticRenderFns } from "./recovery-ways.vue?vue&type=template&id=19e5dd3c&scoped=true"
import script from "./recovery-ways.vue?vue&type=script&lang=js"
export * from "./recovery-ways.vue?vue&type=script&lang=js"
import style0 from "./recovery-ways.vue?vue&type=style&index=0&id=19e5dd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e5dd3c",
  null
  
)

export default component.exports